import React, { useEffect, useRef, useState } from "react";
import QRScanner from "qr-scanner";
import styles from "./QrScannerComponent.module.css";
import load from '../../../../img/loadingScanner.png';

const QrScannerComponent = ({ onScan, onError }) => {
    const [isCameraReady, setIsCameraReady] = useState(false); // 💡 Показываем заставку до готовности камеры
    const videoRef = useRef(null);
    const qrScannerRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (videoRef.current) {
                const scanner = new QRScanner(videoRef.current, (result) => {
                    onScan({ text: result });
                });

                qrScannerRef.current = scanner;

                scanner.start()
                    .then(() => setIsCameraReady(true)) // ✅ Скрываем заставку
                    .catch(onError);

                clearInterval(interval); // Запускаем только один раз
            }
        }, 300);

        return () => {
            clearInterval(interval);
            qrScannerRef.current?.stop();
        };
    }, [onScan, onError]);

    return (
        <div className={styles.scannerContainer}>
            {/* Камера */}
            <video
                ref={videoRef}
                className={styles.scannerVideo}
                style={{ opacity: isCameraReady ? 1 : 0 }}
            />

            {/* Заставка, пока камера не готова */}
            {!isCameraReady && (
                <div className={styles.overlay}>
                    <p>⏳ Подключение камеры...</p>
                </div>
            )}
        </div>
    );
};

export default QrScannerComponent;